/**
 * Hero banner slider (Swiper) custom element.
 * Expects global Swiper from swiper.min.js (deferred in theme.liquid).
 */
class PmdHero extends HTMLElement {
  /** @type {InstanceType<typeof Swiper> | null} */
  #swiper = null;

  /** @type {ReturnType<typeof setTimeout> | null} */
  #initTimer = null;

  connectedCallback() {
    this.#initSwiper();
  }

  disconnectedCallback() {
    if (this.#initTimer !== null) {
      clearTimeout(this.#initTimer);
      this.#initTimer = null;
    }

    if (this.#swiper) {
      this.#swiper.destroy(true, true);
      this.#swiper = null;
    }
  }

  #initSwiper() {
    const swiperEl = this.querySelector('.swiper');
    if (!swiperEl || this.#swiper) return;

    if (typeof Swiper === 'undefined') {
      this.#initTimer = setTimeout(() => {
        this.#initTimer = null;
        this.#initSwiper();
      }, 120);
      return;
    }

    const effect = this.dataset.slideEffect || 'slide';
    /** @type {Record<string, unknown>} */
    const config = {
      loop: this.dataset.loop !== 'false',
      speed: Number(this.dataset.slideSpeed) || 700,
      effect,
      grabCursor: true,
      keyboard: { enabled: true },
      a11y: { enabled: true },
      rtl: document.documentElement.dir === 'rtl',
    };

    if (effect === 'fade') {
      config.fadeEffect = { crossFade: true };
    }

    if (this.dataset.autoplay === 'true') {
      config.autoplay = {
        delay: Number(this.dataset.autoplayDelay) || 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    const paginationEl = this.querySelector('.swiper-pagination');
    if (paginationEl) {
      config.pagination = { el: paginationEl, clickable: true };
    }

    const nextEl = this.querySelector('.swiper-button-next');
    const prevEl = this.querySelector('.swiper-button-prev');
    if (nextEl && prevEl) {
      config.navigation = { nextEl, prevEl };
    }

    this.#swiper = new Swiper(swiperEl, config);
  }
}

if (!customElements.get('pmd-hero')) {
  customElements.define('pmd-hero', PmdHero);
}
